const filterByLocation = (highways, location) => !location
    ? highways
    : highways.filter((highway) => highway.location === location)

export {
    filterByLocation,
}
